import { lazy, ReactElement } from 'react';
import { EAppRoutes } from '@common/enums';
import { IRouteItem } from '@common/interfaces';
import { ECreativeCtvFormat } from '@features/creatives/creatives-builder/enums/ctv.enums';
import { generateRouteElements } from './generateRouteElements';

const BannerBuilderLazy = lazy(() => import('@pages/Creatives/CreativesBuilder/CreativeBannerBuilder'));
const BannerEditLazy = lazy(() => import('@pages/Creatives/CreativesEdit/CreativeBannerEdit'));
const BannerPreviewLazy = lazy(() => import('@pages/Creatives/CreativesPreview/CreativeBannerPreview'));
const NativeBuilderLazy = lazy(() => import('@pages/Creatives/CreativesBuilder/CreativeNativeBuilder'));
const NativeEditLazy = lazy(() => import('@pages/Creatives/CreativesEdit/CreativeNativeEdit'));
const NativePreviewLazy = lazy(() => import('@pages/Creatives/CreativesPreview/CreativeNativePreview'));
const NativeSlideshowLazy = lazy(() => import('@pages/Creatives/CreativesBuilder/CreativeNativeSlideshowBuilder'));
const NativeSlideshowEditLazy = lazy(() => import('@pages/Creatives/CreativesEdit/CreativeNativeSlideshowEdit'));
const NativeVideoBuilderLazy = lazy(() => import('@pages/Creatives/CreativesBuilder/CreativeNativeVideoBuilder'));
const NativeVideoEditLazy = lazy(() => import('@pages/Creatives/CreativesEdit/CreativeNativeVideoEdit'));
const VideoBuilderLazy = lazy(() => import('@pages/Creatives/CreativesBuilder/CreativeVideoBuilder'));
const VideoEditLazy = lazy(() => import('@pages/Creatives/CreativesEdit/CreativeVideoEdit'));
const VideoPreviewLazy = lazy(() => import('@pages/Creatives/CreativesPreview/CreativeVideoPreview'));
const AudioBuilderLazy = lazy(() => import('@pages/Creatives/CreativesBuilder/CreativeAudioBuilder'));
const AudioEditLazy = lazy(() => import('@pages/Creatives/CreativesEdit/CreativeAudioEdit'));
const AudioPreviewLazy = lazy(() => import('@pages/Creatives/CreativesPreview/CreativeAudioPreview'));
const CtvCreateLazy = lazy(() => import('@pages/Creatives/CreativesBuilder/CTV/CreativesCreateCtv'));
const CtvBuilderLazy = lazy(() => import('@pages/Creatives/CreativesBuilder/CTV/CreativesCtvBuilder'));
const CtvCreativeEditLazy = lazy(() => import('@pages/Creatives/CreativesEdit/CreativeCtvEdit'));
const CtvVariantPreviewLazy = lazy(() => import('@pages/Creatives/CreativesPreview/CreativeCtvVariantPreview'));
const PalBuilderLazy = lazy(() => import('@pages/Creatives/CreativesBuilder/CreativePalBuilder'));
const PalEditLazy = lazy(() => import('@pages/Creatives/CreativesEdit/CreativePalEdit'));
const PalPreviewLazy = lazy(() => import('@pages/Creatives/CreativesPreview/CreativePalPreview'));

const routePublicItems: IRouteItem[] = [
  {
    path: EAppRoutes.BannerPreview,
    component: <BannerPreviewLazy />,
  },
  {
    path: EAppRoutes.VideoPreview,
    component: <VideoPreviewLazy />,
  },
  {
    path: EAppRoutes.AudioPreview,
    component: <AudioPreviewLazy />,
  },
  {
    path: EAppRoutes.NativePreview,
    component: <NativePreviewLazy />,
  },
  {
    path: EAppRoutes.NativeNewPreview,
    component: <NativePreviewLazy />,
  },
  {
    path: EAppRoutes.CtvVariantPreview,
    component: <CtvVariantPreviewLazy />,
  },
  {
    path: EAppRoutes.PalPreview,
    component: <PalPreviewLazy />,
  },
];

const routeByIdItems: IRouteItem[] = [
  {
    path: EAppRoutes.NativeEdit,
    component: <NativeEditLazy />,
  },
  {
    path: EAppRoutes.NativeSlideshowEditBuilder,
    component: <NativeSlideshowEditLazy />,
  },
  {
    path: EAppRoutes.NativeVideoEditBuilder,
    component: <NativeVideoEditLazy />,
  },
  {
    path: EAppRoutes.BannerEdit,
    component: <BannerEditLazy />,
  },
  {
    path: EAppRoutes.PalEdit,
    component: <PalEditLazy />,
  },
  {
    path: EAppRoutes.VideoEdit,
    component: <VideoEditLazy />,
  },
  {
    path: EAppRoutes.AudioEdit,
    component: <AudioEditLazy />,
  },
  {
    path: EAppRoutes.CtvCreativeEdit,
    component: <CtvCreativeEditLazy />,
  },
];

const routeItems: IRouteItem[] = [
  {
    path: EAppRoutes.BannerBuilder,
    component: <BannerBuilderLazy />,
  },
  {
    path: EAppRoutes.NativeBuilder,
    component: <NativeBuilderLazy />,
  },
  {
    path: EAppRoutes.NativeSlideshowBuilder,
    component: <NativeSlideshowLazy />,
  },
  {
    path: EAppRoutes.NativeVideoBuilder,
    component: <NativeVideoBuilderLazy />,
  },
  {
    path: EAppRoutes.VideoBuilder,
    component: <VideoBuilderLazy />,
  },
  {
    path: EAppRoutes.AudioBuilder,
    component: <AudioBuilderLazy />,
  },
  {
    path: EAppRoutes.CtvCreate,
    component: <CtvCreateLazy />,
  },
  {
    path: EAppRoutes.PalCreate,
    component: <PalBuilderLazy />,
  },
  {
    path: EAppRoutes.CtvBuilderBrandAmplify,
    component: <CtvBuilderLazy format={ECreativeCtvFormat.BigShow} />,
  },
  {
    path: EAppRoutes.CtvBuilderStandard,
    component: <CtvBuilderLazy format={ECreativeCtvFormat.Standard} />,
  },
];

export const creativesPublicRoutes: ReactElement[] = generateRouteElements(routePublicItems);
export const creativesRoutes = generateRouteElements(routeItems);
export const creativesByIdRoutes: ReactElement[] = generateRouteElements(routeByIdItems);
